<script setup lang="ts">
    import { ref, watch } from 'vue';
    import moment from 'moment';

    const props = defineProps({
        dateOnly: {
            type: Boolean,
            required: false,
            default: false
        },
        input: {
            type: [String, null],
            required: false,
            default: ''
        },
        stackDateAndTimeInput: {
            type: Boolean,
            required: false,
            default: false
        },
        appendToBody: {
            type: Boolean,
            required: false,
            default: false
        }
    });

    const date = ref<Date | null>(null);
    const time = ref<Date | null>(null);

    const emit = defineEmits<{
        'dt-picker': [value: string];
    }>();

    watch(
        () => props.input,
        () => {
            if (props.input === '' || props.input === null) {
                date.value = null;
                time.value = null;
            } else {
                const value = moment(props.input).toDate();
                date.value = value;
                time.value = value;
            }
        },
        { immediate: true }
    );

    function handleInput(): void {
        if (props.dateOnly && date.value !== null) {
            emit('dt-picker', date.value ? moment(date.value).format('YYYY-MM-DD') : '');
        } else if (date.value !== null) {
            if (time.value === null) {
                time.value = new Date('00:00');
            }
            const combinedDate = moment(date.value);
            combinedDate.hours(time.value.getHours());
            combinedDate.minutes(time.value.getMinutes());
            emit('dt-picker', combinedDate.format('YYYY-MM-DD HH:mm:ss'));
        } else {
            emit('dt-picker', '');
        }
    }
</script>

<template>
    <div>
        <div
            class="field"
            :class="{'is-grouped': !stackDateAndTimeInput}">
            <b-datepicker
                v-model="date"
                :date-formatter="() => moment(date).format('YYYY-MM-DD')"
                placeholder="Click to select date..."
                icon="calendar-today"
                editable
                :append-to-body="appendToBody"
                @update:model-value="handleInput" />
            <b-timepicker
                v-if="!dateOnly"
                v-model="time"
                placeholder="Click to select time..."
                icon="clock"
                editable
                hour-format="24"
                :append-to-body="appendToBody"
                @update:model-value="handleInput" />
        </div>
    </div>
</template>
